import { currecyFormat } from '@/mixins/currency'
import DateTime from '@/components/DateTime'

import getValue from '@/components/table/helpers/getValue'
// import StatusView from './StatusView.vue'
import SetApplication from './SetApplication.vue'

const FilterColumnIcon = () => import('@/components/table/filters/FilterColumnIcon')
const DateFilter = () => import('@/components/table/filters/Date')
const RangeFilter = () => import('@/components/table/filters/Range')
const InputFilter = () => import('@/components/table/filters/Input')

export default {
  data() {
    return {
      columns: [
        {
          field: 'created_at',
          title: 'Дата',
          align: 'left',
          key: 'date',
          width: 120,
          renderBodyCell: ({ row }) => {
            return (
              <div style="min-width: 120px">
                <DateTime date={row.created_at} />
              </div>
            )
          },
          filterCustom: {
            render: ({ closeFn }) => (
              <DateFilter closeFn={closeFn} title="Дата платежа:" queryKey="created_at" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['created_at']} />,
          },
        },
        {
          field: 'amount',
          title: 'Сумма, ₽',
          key: 'amount',
          align: 'right',
          width: 130,
          renderBodyCell: ({ row }) => currecyFormat(row.amount),
          filterCustom: {
            render: ({ closeFn }) => (
              <RangeFilter closeFn={closeFn} title="Сумма, ₽:" queryKey="sum" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['sum']} />,
          },
        },
        {
          field: 'paymentPurpose',
          title: 'Назначение',
          key: 'purpose',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return <div style="min-width: 300px">{getValue(row, 'paymentPurpose')}</div>
          },
          filterCustom: {
            render: ({ closeFn }) => (
              <InputFilter closeFn={closeFn} title="Назначение:" queryKey="purpose" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['purpose']} />,
          },
        },
        {
          field: 'contragentName',
          title: 'Контрагент',
          key: 'contragent',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return <div style="min-width: 250px">{getValue(row, 'contragentName')}</div>
          },
          filterCustom: {
            render: ({ closeFn }) => (
              <InputFilter closeFn={closeFn} title="Контрагент:" queryKey="contragent" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['contragent']} />,
          },
        },
        // {
        //   field: 'status',
        //   title: 'Статус',
        //   align: 'left',
        //   renderBodyCell: ({ row }) => {
        //     return (
        //       <div style="min-width: 100px">
        //         <StatusView status={row.status} />
        //       </div>
        //     )
        //   },
        // },
        {
          field: 'application',
          title: 'Аккаунт',
          key: 'app',
          align: 'left',
          width: 350,
          renderBodyCell: ({ row }) => {
            if (row.appId) return row.application.domain

            return <SetApplication row={row} onRefreshTable={this.getPaymentsList} />
          },
          filterCustom: {
            render: ({ closeFn }) => (
              <InputFilter closeFn={closeFn} title="Аккаунт:" queryKey="domain" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['domain']} />,
          },
        },
      ],
    }
  },
}
